import contract from './contracts/Panda.json';
import { ethers } from 'ethers';



export const mint = async () => {
    if(window.ethereum){
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const signer = provider.getSigner();
        const contractAddress = "0xEc375667b52AAaa42211B73eB15fAd6bcc5ced4A";
        const nftContract = new ethers.Contract(contractAddress, contract.abi, signer);

        let txnHash = await nftContract.mintNFT(window.ethereum.selectedAddress, "https://gateway.pinata.cloud/ipfs/QmRC7KK9mmz9SbMQmRHU2iqcCCtWQbiF6tP5w7B3YuPXVE")
        return txnHash
    }
}



